import { notification } from "antd";
import { globalAppConfig } from "../../config";
import Helper from "../../Helper";

export type ShareItemType = "location" | "dropoff" | "project" | "delivery" | "equipment";

export const shareValuesConstructor = (
    invitee: string | null,
    shareItemType: ShareItemType,
    shareItemId: number,
    mappableType?: string
) => {
    const values: { [key: string]: any } = {
        invitee: invitee,
    };

    // Any map item is shared by its backend type and id.
    if (mappableType && shareItemId) {
        values["mappable_type"] = mappableType;
        values["mappable_id"] = shareItemId;
    }

    if (shareItemType === "delivery" && shareItemId) {
        values["delivery"] = shareItemId;
    }

    // No additional values needed for project sharing

    return JSON.stringify({
        values,
    });
};

export const shareProjectItem = async (
    teamSubdomain: string,
    projectToken: string,
    invitee: string | null,
    shareItemType: ShareItemType,
    shareItemId: number,
    mappableType?: string
) => {
    const url = `${Helper.baseUrlAltSubdomain(teamSubdomain)}/projects/${projectToken}/share`;
    const options = {
        method: "post",
        body: shareValuesConstructor(invitee, shareItemType, shareItemId, mappableType),
    };
    return Helper.plotFetch(url, options, true)
        .then((response) => {
            if (response.ok) {
                notification.success({
                    message: `Shared ${shareItemType.charAt(0).toUpperCase()}${shareItemType.slice(1)}`,
                    description: `${shareItemType.charAt(0).toUpperCase()}${shareItemType.slice(1)} has been shared.`,
                });

                return response.json();
            }
        })
        .catch((err) => {
            notification.error({
                message: `Failed to Share ${shareItemType.charAt(0).toUpperCase()}${shareItemType.slice(1)}`,
                description: `The ${shareItemType.charAt(0).toUpperCase()}${shareItemType.slice(1)} could not be shared: ${err}`,
                duration: globalAppConfig.NOTIFICATION_DURATION,
            });
        });
};
